import { render, staticRenderFns } from "./Genomes.vue?vue&type=template&id=7b4a3f8e&scoped=true&"
import script from "./Genomes.vue?vue&type=script&lang=js&"
export * from "./Genomes.vue?vue&type=script&lang=js&"
import style0 from "./Genomes.vue?vue&type=style&index=0&id=7b4a3f8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4a3f8e",
  null
  
)

export default component.exports